import { fetchHealthCard } from 'actions/healthCard';
import { Checklist } from 'features/studentChecklist/components';
import { HealthCardDispatch } from 'models/healthCard';
import { Policy } from 'models/policies';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getHealthCardDetail, getHealthCardSteps } from 'selectors/healthCard';

interface HealthCardChecklistProps {
  policy: Policy;
}

export const HealthCardChecklist = ({ policy }: HealthCardChecklistProps) => {
  const showChecklist = policy?.type === 'PUBLIC_HEALTH';
  const healthCard = useSelector(
    getHealthCardDetail(policy?.attributes?.healthCardId || null)
  );
  const isCompleted = healthCard?.isFinalized;
  const { steps, title } = getHealthCardSteps(policy, healthCard);
  const dispatch = useDispatch<HealthCardDispatch>();

  useEffect(() => {
    const healthCardId = policy?.attributes.healthCardId;
    if (healthCardId) {
      dispatch(fetchHealthCard(healthCardId));
    }
  }, [policy?.attributes.healthCardId, dispatch]);

  if (!showChecklist || steps.length === 0) return null;

  return (
    <Checklist
      title={title}
      steps={steps}
      submittedChecklist={isCompleted}
      policy={policy}
    />
  );
};
